/* eslint-disable import/prefer-default-export */
import { SnackbarApiErrorMessage } from '@ui-framework/index';

const fetchTechnicians = async (params, data = {}) => {
  // gets the address of the Service Provider
  const url = `${params.getApiUrl()}/service-directory/find-technicians`;

  const response = await params.post(url, data);
  if (response?.ok) {
    return response.data;
  }
  params.snackbar.showMessage({
    type: 'error',
    data: <SnackbarApiErrorMessage errors={response?.errors} />,
  });
  return null;
};

export { fetchTechnicians };
